export default "__VITE_ASSET__l$gsTOPR__"